import { StringOnly } from "types/baseType";

export const roomCategory:StringOnly[] = [
  {
    id:'etc',
    title:'기타',
    icon:'icon_etc',
    state:'예정',
  },
  {
    id:'CashLedger',
    title:'가계부',
    icon:'icon_cash_ledger',
    state:'예정',
  },
  {
    id:'Travel',
    title:'여행',
    icon:'icon_travel',
    state:'예정',
  },
  {
    id:'Memo',
    title:'메모장',
    icon:'icon_memo',
    state:'예정',
  },
  {
    id:'Calendar',
    title:'달력',
    icon:'icon_calendar',
    state:'예정',
  },
  
]